const NOTCH =
  "polygon(0 0, calc(100% - 26px) 0, 100% 26px, 100% 100%, 26px 100%, 0 calc(100% - 26px))";

export default function VesselFrame({ src, alt, className = "", imgClassName = "", testId = "vessel-frame" }) {
  return (
    <figure data-testid={testId} className={`group relative ${className}`}>
      <div className="relative h-full w-full overflow-hidden" style={{ clipPath: NOTCH }}>
        <img
          src={src}
          alt={alt}
          loading="lazy"
          className={`h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.04] ${imgClassName}`}
        />
        <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-[#030F26]/85 via-[#030F26]/20 to-transparent" />
      </div>
      <div
        className="pointer-events-none absolute inset-0 border border-[#C5A059]/40 transition-colors duration-500 group-hover:border-[#C5A059]/80"
        style={{ clipPath: NOTCH }}
      />
    </figure>
  );
}
